import React from 'react';
import { motion } from 'framer-motion';

type ResolvedConversationFooterProps = {
  onStartNewConversation: () => void;
  message?: string;
};

export function ResolvedConversationFooter({
  onStartNewConversation,
  message = 'This conversation is closed. Messages are read-only.',
}: ResolvedConversationFooterProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-card shadow-top-soft"
    >
      <div className="container flex flex-col items-center justify-center p-3 gap-2 text-center">
        <span className="text-xs text-muted-foreground">{message}</span>
        <p className="m-0 text-sm font-medium text-foreground">Still need help?</p>
        <button
          type="button"
          onClick={onStartNewConversation}
          className="h-8 rounded-md px-4 text-sm bg-primary text-primary-foreground"
        >
          Start new conversation
        </button>
      </div>
    </motion.div>
  );
}
